var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 0.358337H1.125C0.492188 0.358337 0 0.873962 0 1.48334V8.23334C0 8.86615 0.492188 9.35834 1.125 9.35834H10.875C11.4844 9.35834 12 8.86615 12 8.23334V1.48334C12 0.873962 11.4844 0.358337 10.875 0.358337ZM1.125 1.10834H10.875C11.0625 1.10834 11.25 1.29584 11.25 1.48334V2.46771C10.7344 2.88959 9.98438 3.49896 7.71094 5.30365C7.3125 5.63177 6.53906 6.38177 6 6.35834C5.4375 6.38177 4.66406 5.63177 4.26562 5.30365C1.99219 3.49896 1.24219 2.88959 0.75 2.46771V1.48334C0.75 1.29584 0.914062 1.10834 1.125 1.10834ZM10.875 8.60834H1.125C0.914062 8.60834 0.75 8.44427 0.75 8.23334V3.42865C1.26562 3.87396 2.10938 4.55365 3.79688 5.88959C4.28906 6.28802 5.13281 7.13177 6 7.10834C6.84375 7.13177 7.6875 6.28802 8.17969 5.88959C9.86719 4.55365 10.7109 3.87396 11.25 3.42865V8.23334C11.25 8.44427 11.0625 8.60834 10.875 8.60834Z",
    fill: "#959CA0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.6ff10088.svg";
export { ForwardRef as ReactComponent };